import React from 'react';
import { AccordionWrapper } from '../Styled/StyledWrappers';

interface IAccordion {
  isActive: boolean;
  content: JSX.Element;
}

export const Accordion = (props: IAccordion): JSX.Element => {
  const { isActive, content } = props;
  return <AccordionWrapper data-testid="accordion">{isActive ? content : ''}</AccordionWrapper>;
};
